import React, { useEffect, useState } from 'react';
import { Button, Container } from '@infoods/lifebase-ui';

import { observer } from 'mobx-react';

import { angularizeWithProviders } from '../../../../shared/providers';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { entityInfoService } from '../../../../entity-management';
import { ScanIqAutomatedPayment } from '../../entity-profile/ScanIqAutomatedPayment/ScanIqAutomatedPayment';
import { ErrorState } from '../../../../shared/components/ErrorState/ErrorState';
import { goToHomePage } from '../../../../shared/utils/angularUtils';

const NgzScanIqSubscriptionPage = observer(() => {
  const entityId = loggedInUserDataStore.getEntityId();
  const { scanIqBillingType } = loggedInUserDataStore;

  const [isStripeConnected, setIsStripeConnected] = useState(false);

  useEffect(() => {
    entityInfoService.getEntityAdminInfo().then((info) => {
      setIsStripeConnected(info.isStripeAccountConnected);
    });
  }, [entityId]);

  return (
    <Container>
      {scanIqBillingType.SELF_BILLING && (
        <ErrorState
          title="Subscription is not available for self-billing"
          description="Subscription can only be managed for entities on automated billing."
        >
          <Button variant="contained" onClick={goToHomePage}>
            Return to the Main Page
          </Button>
        </ErrorState>
      )}
      {scanIqBillingType.AUTOMATED_BILLING && (
        <ScanIqAutomatedPayment
          entityId={entityId}
          isStripeConnected={isStripeConnected}
        />
      )}
    </Container>
  );
});

angularizeWithProviders(NgzScanIqSubscriptionPage, 'ngzScanIqSubscriptionPage', {});

export { NgzScanIqSubscriptionPage };
